import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  approveAiDraft,
  createAiDraft,
  dismissAiDraft,
  listAiDrafts,
  type ApproveAiDraftInput,
  type CreateAiDraftInput,
} from '@/api/ai'

export function useAiDrafts(dealId: string) {
  return useQuery({ queryKey: ['ai-drafts', dealId], queryFn: () => listAiDrafts(dealId) })
}

export function useCreateAiDraft(dealId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: CreateAiDraftInput) => createAiDraft(dealId, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['ai-drafts', dealId] }),
  })
}

export function useApproveAiDraft(dealId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: ApproveAiDraftInput }) =>
      approveAiDraft(id, input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['ai-drafts', dealId] })
      // approval sends a message — same invalidations as a manual send
      qc.invalidateQueries({ queryKey: ['activities', dealId] })
      qc.invalidateQueries({ queryKey: ['deal', dealId] })
      qc.invalidateQueries({ queryKey: ['attention'] })
    },
  })
}

export function useDismissAiDraft(dealId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => dismissAiDraft(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['ai-drafts', dealId] }),
  })
}
